import { Component, Input, OnInit } from '@angular/core';
import { CclCounts } from 'src/app/core/interfaces/status-counts/ccl-counts';

@Component({
  selector: 'app-ccl-counts',
  templateUrl: './ccl-counts.component.html',
  styleUrls: ['./ccl-counts.component.scss'],
})
export class CclCountsComponent implements OnInit {
  @Input() cclCounts: CclCounts;

  constructor() {}

  ngOnInit(): void {}
}
